import { render, staticRenderFns } from "./PriceNegotiationsReport.vue?vue&type=template&id=1dfa4717&scoped=true&"
import script from "./PriceNegotiationsReport.vue?vue&type=script&lang=js&"
export * from "./PriceNegotiationsReport.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1dfa4717",
  null
  
)

export default component.exports